import React, { createContext, useState, useMemo, useContext, useCallback } from 'react';

// 1. Create the context
const LoadingContext = createContext();

// 2. Create the provider component
export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  // --- THIS IS THE FIX ---
  // We use useCallback to ensure these functions *never* change
  // and are not re-created on every render.

  const showLoader = useCallback(() => {
    setIsLoading(true);
  }, []); // Empty array means this function is created only once

  const hideLoader = useCallback(() => {
    setIsLoading(false);
  }, []); // Empty array means this function is created only once
  // --- END OF FIX ---


  // Now, the value memoized here will have stable functions
  const value = useMemo(() => ({
    isLoading,
    showLoader,
    hideLoader,
  }), [isLoading, showLoader, hideLoader]); // Dependencies are all stable

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};

// 3. Create a custom hook to use the context easily
export const useLoading = () => {
  return useContext(LoadingContext);
};